<div class="mselect-field">
    @if (label) {
        <label class="mselect-label">{{ label | translate }}</label>
    }
    <div class="mselect-wrapper" [class.is-disabled]="disabled" [class.is-open]="isOpen">
        <div class="mselect-control" role="button" tabindex="0" (click)="togglePanel()" (keydown.enter)="togglePanel()">
            @if (value.length === 0) {
                <span class="mselect-placeholder">{{ placeholder | translate }}</span>
            } @else {
                <div class="mselect-chips">
                    @for (chip of value; track chip) {
                        <span class="mselect-chip">
                            <span class="mselect-chip-label">{{ chipLabel(chip) }}</span>
                            @if (!disabled) {
                                <button type="button" class="mselect-chip-remove" (click)="removeChip(chip, $event)" aria-label="remove">
                                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>
                                </button>
                            }
                        </span>
                    }
                </div>
            }
            <img src="assets/images/dropDownArrow.svg" alt="" class="mselect-arrow" />
        </div>
        @if (isOpen && !disabled) {
            <div class="mselect-panel">
                @for (option of options; track option.value) {
                    <label class="mselect-option" [class.is-disabled]="isOptionDisabled(option)">
                        <input
                            type="checkbox"
                            [checked]="isSelected(option)"
                            [disabled]="isOptionDisabled(option)"
                            (change)="toggleOption(option, $event)"
                            (click)="$event.stopPropagation()"
                        />
                        <span class="mselect-option-label">{{ option.label }}</span>
                    </label>
                } @empty {
                    <div class="mselect-empty">{{ 'noRecordsFound' | translate }}</div>
                }
            </div>
        }
    </div>
</div>
